module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_5_5.f709b0ae.png";